export default __webpack_public_path__ + "static/media/foods.2fe469ec.mp4";